import React from 'react';
const LoadingIndicator = () => {
    return (
        <>
            <div className="spinner-border" role="status"></div>
        </>
    );
}
export default LoadingIndicator;